import * as React from 'react';

import { LoadingContainer } from '@atlassian/help-center-common-component/loading-container';

import { NoteContentContainer } from './styled';

interface NoteContentProps {
    isLoading: boolean;
    isCentered?: boolean;
    children: React.ReactNode;
}

export class NoteContent extends React.Component<NoteContentProps> {
    render() {
        return (
            <NoteContentContainer isCentered={this.props.isCentered}>
                <LoadingContainer isLoading={this.props.isLoading} loadingPosition="fill-container">
                    {this.props.children}
                </LoadingContainer>
            </NoteContentContainer>
        );
    }
}
